import { render, staticRenderFns } from "./NGuest.vue?vue&type=template&id=5efc27df"
import script from "./NGuest.vue?vue&type=script&lang=js"
export * from "./NGuest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports